import {
  ITranslatesRepository,
  TTechnicalTranslateRequestProps,
  TTechnicalTranslateResponse,
  TTechnicalTranslatesResponse,
  TTranslatesResponse,
} from "./types";

import { IRequestClient } from "@modules/request/types/instance";

export class TranslatesRepository implements ITranslatesRepository {
  public readonly abortControllers = {
    fetchTranslates: new AbortController(),
  };

  public constructor(private requestClient: IRequestClient) {}

  public fetchTechnicalTranslates = async (
    data: TTechnicalTranslateRequestProps
  ): Promise<TTechnicalTranslatesResponse> => {
    if (this.abortControllers.fetchTranslates) {
      this.abortControllers.fetchTranslates.abort();
    }
    this.abortControllers.fetchTranslates = new AbortController();

    return await this.requestClient.get(`translations`, {
      params: {
        per_page: data.per_page,
        segment: data.segment,
        sorting_direction: data.sorting_direction,
      },
      signal: this.abortControllers.fetchTranslates.signal,
    });
  };

  public fetchTranslates = async (): Promise<TTranslatesResponse> => {
    if (this.abortControllers.fetchTranslates) {
      this.abortControllers.fetchTranslates.abort();
    }
    this.abortControllers.fetchTranslates = new AbortController();

    return await this.requestClient.get(
      `translations?per_page=100000000&sorting_direction=asc`,
      {
        signal: this.abortControllers.fetchTranslates.signal,
      }
    );
  };

  public changeTranslate = async (
    translationId: number,
    data: {
      id: string;
      segment: string;
      context: string | null;
      key: string;
      translations: {
        en: string;
        ar: string;
      };
    }
  ): Promise<TTechnicalTranslateResponse> => {
    if (this.abortControllers.fetchTranslates) {
      this.abortControllers.fetchTranslates.abort();
    }
    this.abortControllers.fetchTranslates = new AbortController();
    return await this.requestClient.put(`translations/${translationId}`, data, {
      signal: this.abortControllers.fetchTranslates.signal,
    });
  };

  public createTranslate = async (data: {
    id: string;
    segment: string;
    context: string | null;
    key: string;
    translations: {
      en: string;
      ar: string;
    };
  }): Promise<TTechnicalTranslateResponse> => {
    if (this.abortControllers.fetchTranslates) {
      this.abortControllers.fetchTranslates.abort();
    }
    this.abortControllers.fetchTranslates = new AbortController();

    return await this.requestClient.post(`/translations`, data, {
      signal: this.abortControllers.fetchTranslates.signal,
    });
  };

  public beforeDestroy = (): void => {
    Object.values(this.abortControllers).forEach((abortController) =>
      abortController.abort()
    );
  };
}
